import type {ActionReturn} from 'svelte/action';
import {isNull} from 'shared/utils/custom-utils';

export const FOCUS_OUTSIDE_EVENT_TYPE = 'focus-outside';
type OnFocusOutsideEventType = `on:${typeof FOCUS_OUTSIDE_EVENT_TYPE}`;

type Attributes = {
    [key in OnFocusOutsideEventType]?: (e: CustomEvent<void>) => void;
};


export function focusOutside(node: HTMLElement): ActionReturn<void, Attributes> {

    const focusoutListener = (event: FocusEvent) => {
        if (!isNodeOrNull(event.relatedTarget)) {
            return;
        }

        if (!node.contains(event.relatedTarget)) {
            node.dispatchEvent(new CustomEvent(FOCUS_OUTSIDE_EVENT_TYPE))
        }
    }

    node.addEventListener('focusout', focusoutListener);
    return {
        destroy: () => node.removeEventListener('focusout', focusoutListener)
    }
}

const isNodeOrNull = (node: unknown): node is Node | null => isNull(node) || node instanceof Node;